import styled from 'styled-components';

import { Subtitle } from '../../../components/Typography';
import { getTypography } from '../../../shared/utils/style-utils';

export const StyledSubtitle = styled(Subtitle)`
  ${({ theme }) => getTypography(theme.typography.heading.h5)};
`;
